export default __webpack_public_path__ + "static/media/LCBC_wide_compact_full.86be6312.png";